import axios from '@/extensions/axios'

let getIsoTime = () => {
  let isoDate = new Date()
  isoDate.setMilliseconds(0)
  isoDate.setSeconds(0)
  return isoDate.toISOString().substring(0, 19)
}

const actions = {
  get ({ commit, rootState }) {
    return axios.get('sites/' + rootState.site.active.slug + '/components').then(({ data }) => {
      commit('SET', data)
    })
  },

  find ({ commit }, uuid) {
    return axios.get('components/' + uuid).then(({ data }) => {
      if (data.language) {
        data.language = {
          label: data.language.code,
          value: data.language.id
        }
      }
      commit('ADD', data)
    })
  },

  save ({ commit, state, rootState }) {
    state.newComponent.published_at = getIsoTime()
    state.newComponent.language_id = state.newComponent.language ? state.newComponent.language.value : null
    if (state.newComponent.uuid) {
      return axios.put('components/' + state.newComponent.uuid, state.newComponent)
        .then(({ data }) => {
          commit('ADD', data)
          return data
        })
    }
    return axios.post('sites/' + rootState.site.active.slug + '/components', state.newComponent)
      .then(({ data }) => {
        commit('ADD', data)
        return data
      })
  },

  remove ({ commit }, component) {
    return axios.delete('components/' + component.uuid).then(() => {
      commit('REMOVE', component)
    })
  }
}

export default actions
